import * as React from "react";
import ContentCopy from "@mui/icons-material/ContentCopy";
import CloudUpload from "@mui/icons-material/CloudUpload";
import { Button, Tooltip } from "@mui/material";
import { buildSchema, buildCollection, ExtraActionsParams } from "@camberi/firecms";
import { getFunctions, httpsCallable } from "firebase/functions";
import { initializeApp, getApp } from "firebase/app";
import { getFirestore, collection as firestoreCollection, doc } from "firebase/firestore";
import { firebaseConfig } from "../firebaseConfig";

export default class Seasons {

    constructor() {

    }

    static BuildCollection (isadmin:boolean, issuperadmin:boolean, groupname:string) {
      return buildCollection({
        path: "seasons",
        group:groupname,
        exportable:false,
//                  textSearchEnabled: true,
        schema: Seasons.schema(),
        name: "Seasons",
        extraActions: Seasons.actions,
        
        permissions: ({entity,path,user,authController,context}) => { 
            return ({
                read: isadmin,
                create: isadmin,
                update: issuperadmin,
                delete: issuperadmin
            });
        },



      })
    }

    static schema () {
        return buildSchema({
            name: "Seasons",
            properties: {
              nameKey: {
                title: "Name",
                dataType: "string"
              },
              descriptionKey: {
                title: "description",
                dataType: "string"
              },
              startDate: {
                title: "season availability starts",
                dataType: "timestamp"
              },
              endDate: {
                title: "season availability ends",
                dataType: "timestamp"
              },
              id: {
                title: "id",
                dataType: "number"
              },
              image: {
                title: "image",
                dataType: "string",
              },
              public: {
                title: "public",
                dataType: "boolean"
              },    
                
            }
          });
    }

    static actions(extraActionParams: ExtraActionsParams) {
      const disabled = extraActionParams.selectionController.selectedEntities.length === 0;

      const duplicateDocument = async () => {
        if (extraActionParams.selectionController.selectedEntities.length === 0) return;

        const selectedEntity = extraActionParams.selectionController.selectedEntities[0];
        const dataSource = extraActionParams.context.dataSource;
        const snackbar = extraActionParams.context.snackbarController;
        const entityCollection = extraActionParams.collection;

        try {
          let app;
          try {
            app = getApp();
          } catch {
            app = initializeApp(firebaseConfig);
          }
          const db = getFirestore(app);
          const newDocId = doc(firestoreCollection(db, selectedEntity.path)).id;

          const entityData = selectedEntity.values;
          const newData = { ...entityData };

          newData.public = false;

          if (newData.nameKey) {
            newData.nameKey = `${newData.nameKey} (Copy)`;
          }

          await dataSource.saveEntity({
            path: selectedEntity.path,
            entityId: newDocId,
            values: newData,
            status: "new",
            schema: entityCollection.schema
          });

          snackbar.open({
            type: "success",
            title: "Duplicate",
            message: "Season duplicated successfully"
          });
        } catch (error) {
          snackbar.open({
            type: "error",
            title: "Error",
            message: `Failed to duplicate season: ${error}`
          });
        }
      };

      const copyToLive = async () => {
        if (extraActionParams.selectionController.selectedEntities.length === 0) return;

        const selectedEntity = extraActionParams.selectionController.selectedEntities[0];
        const snackbar = extraActionParams.context.snackbarController;
        const user = extraActionParams.context.authController.user;

        if (!user) {
          snackbar.open({
            type: "error",
            title: "Error",
            message: "User not authenticated"
          });
          return;
        }

        try {
          let app;
          try {
            app = getApp();
          } catch {
            app = initializeApp(firebaseConfig);
          }
          const functions = getFunctions(app, "europe-west3");
          const copyToLiveFunction = httpsCallable(functions, "copyDocumentToLive");

          await copyToLiveFunction({
            props: {
              collection: "seasons"
            },
            userID: user.uid,
            documentID: selectedEntity.id
          });

          snackbar.open({
            type: "success",
            title: "Copy to Live",
            message: "Season copied to live project successfully"
          });
        } catch (error) {
          snackbar.open({
            type: "error",
            title: "Error",
            message: `Failed to copy season to live: ${error}`
          });
        }
      };

      return [
        <Tooltip title="Duplicate selected season" key="duplicate-tip">
          <Button disabled={disabled} onClick={duplicateDocument} color="primary" key="duplicate">
            <ContentCopy />
          </Button>
        </Tooltip>,
        <Tooltip title="Copy selected season to live project" key="copy-live-tip">
          <Button disabled={disabled} onClick={copyToLive} color="primary" key="copy-live">
            <CloudUpload />
          </Button>
        </Tooltip>
      ];
    }

    
}